<div v-if="item" class="tt-o-byline tt-u-spacing--left--xs">
  <!--<a v-if="item.user" href="" class="tt-o-byline__item tt-o-byline__action" @click.prevent="selectedAuthor" rel="nofollow">{{item.user | formatName}}</a>-->
  <span v-if="item.user" class="tt-o-byline__item tt-o-byline__author">{{ item.user | formatName }}</span>
  <span v-else class="tt-o-byline__item" v-html="$msg('byline.anon')"></span>
  <tt-badge v-if="item.expertLabel" type="expert" v-html="item.expertLabel"></tt-badge>
  <tt-badge v-else-if="item.isIndependentExpert" type="expert" v-html="$msg('badge.expert')"></tt-badge>
  <tt-badge v-else-if="item.isStaff" type="staff" v-html="$msg('badge.staff')"></tt-badge>
  <span class="tt-o-byline__dot"></span>
  <time :datetime="item.dateCreated" class="tt-o-byline__item tt-o-byline__on-date">{{item.dateCreatedFormatted}}</time>
  <span v-if="purchasedText" class="tt-o-byline__dot"></span>
  <time v-if="purchasedText" class="tt-o-byline__item tt-o-byline__purchased" :datetime="purchasedDatetime" v-html="purchasedText"></time>
  <span v-if="syndicationText" class="tt-o-byline__dot"></span>
  <span v-if="syndicationText" class="tt-o-byline__item tt-o-byline__syndication-source" v-html="syndicationText"></span>
  <template v-for="menuItem in menuItems">
    <span class="tt-o-byline__dot" :key="menuItem.name + '-byline'"></span>
    <a v-if="!menuItem.disabled" href=""
       :class="['tt-o-byline__options-item--' + menuItem.name]"
       class="tt-o-byline__item tt-o-byline__action tt-o-byline__options-item"
       @click.prevent="menuItemSelected(menuItem)"
       :aria-controls="menuItem.cntrlsId"
       :aria-expanded="menuItem.expanded"
       :key="menuItem.name + '-link'"
       rel="nofollow"
       v-html="menuItem.title"></a>
    <span v-if="menuItem.disabled" :class="['tt-o-byline__options-item--' + menuItem.name]" class="tt-o-byline__item tt-o-byline__action tt-o-byline__options-item tt-o-disabled" tabindex="-1" :key="menuItem.name + '-disabled'" v-html="menuItem.title"></span>
  </template>
  <tt-menu v-if="menuItems">
    <tt-button slot="menuTrigger" type="icon" class="tt-o-byline__menu-trigger" :aria-label="$msg('byline.optionsMenu')"><tt-icon name="more-h" size="sm"></tt-icon></tt-button>
    <tt-menu-list class="tt-o-byline__menu-list" :menuItems="menuItems" @menuItemSelected="menuItemSelected"></tt-menu-list>
  </tt-menu>
</div>



// WEBPACK FOOTER //
// ./src/objects/byline/byline.html